import { render, staticRenderFns } from "./complaintStore.vue?vue&type=template&id=1d756206&scoped=true&"
import script from "./complaintStore.vue?vue&type=script&lang=js&"
export * from "./complaintStore.vue?vue&type=script&lang=js&"
import style0 from "./complaintStore.vue?vue&type=style&index=0&id=1d756206&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d756206",
  null
  
)

export default component.exports